<template>
  <div class="card" :class="{ [type]: type }">
    <div class="header">
      <div class="card-title">{{ header }}</div>
      <div class="action" v-if="$slots['header-action']" @click="headerAction">
        <slot name="header-action" />
      </div>
    </div>
    <div class="body">
      <slot />
    </div>
    <div class="footer" @click="footerAction" v-if="footer">
      {{ footer }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "Card",
    props: {
      header: {
        type: String,
        required: true
      },
      footer: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: "primary",
        validator: value => ["primary", "secondary"].indexOf(value) >= 0
      }
    },
    methods: {
      headerAction() {
        this.$emit("header-action");
      },
      footerAction() {
        this.$emit("footer-action");
      }
    }
  };
</script>

<style scoped lang="scss">
  .card {
    width: 100%;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
    border-radius: $radius;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: $font-semibold;
      color: $color-white;
      background: $color-primary;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;

      .action {
        font-size: 12px;

        svg {
          font-size: 28px;
          fill: #fff;
          stroke: #fff;
        }
      }

      .card-title {
        padding: 13px $gutter;
        flex-grow: 1;
      }

      button {
        padding-top: 6px;
        padding-bottom: 6px;
        min-width: 0;
        border-left: 1px solid $color-secondary;
        border-radius: 0;
        line-height: 32px;
      }
    }

    .body {
      padding: $gutter;
      font-size: 15px;
    }

    .footer {
      text-align: center;
      border-top: 1px solid $color-gray-light;
      color: $color-secondary;
      font-size: 14px;
      font-weight: $font-semibold;
      padding: 9px 0 13px 0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      cursor: pointer;
    }

    &.secondary {
      box-shadow: none;
      border: $border;

      .header {
        color: $color-black;
        background: $color-gray-light;
        border-bottom: $border;

        button {
          border-left-color: $color-border;
          color: $color-black;
        }
      }
    }
  }
</style>
